$(document).ready(function(){

    $("#open-side-out").click(function(){
        setTimeout(function(){
            $("#slide-out").removeClass("d-none");
        },100);
        setTimeout(function(){
            $("#slide-out").addClass("open-s");
        },200);
        $("#sidenav-overlay").css("display", "block");
        $("#drag-target-overlay").css("display", "block");

    });

    $(".close-slide-out").click(function () {
        $("#slide-out").removeClass("open-s");
        $("#formdata").removeClass("u-unfold--css-animation");
        $("#formdata").removeClass("slideInUp");
        setTimeout(function(){
            $("#sidenav-overlay").css("display", "none");
            $("#drag-target-overlay").css("display", "none");
        },200);
    });
    $("#imprimir").click(function () {
        $("#formdata").addClass("u-unfold--css-animation");
        $("#formdata").addClass("slideInUp");
    });



    $('.backToIndex').click(() => { fillQuotation() });
    let interval_selectpicker = setInterval(() => {
        if($('.selectpicker').children().length > 1){
            $(".bs-title-option").css("display", "none");
            //$('.selectpicker').find('option').get(0).remove();
            //$('.selectpicker').selectpicker('refresh');
            //$('.selectpicker').find('option').get(1).remove();
            $('.selectpicker').selectpicker('refresh');
            if($('.btn-selectpicker').next().find('ul').children().length > 1){clearInterval(interval_selectpicker);}
        }
    }, 1000);

    $('.shadow').removeClass('d-none');

    $('.voucher-form').submit(function(){
        $('.btn-voucher').prop("disabled", true);
        $('.btn-voucher').html('<i class="fa fa-spinner fa-spin fa-fw"></i> Buscando reserva');
        var clave=$('#clave-voucher').val();
        var correo=$('#correo-voucher').val();
        var _token = $('input[name="_token"]').val();
        $.ajax({
            url: '/imprimir-voucher',
            type: 'POST',
            dataType: 'json',
            data: {'clave-r': clave,'correo-r':correo, '_token':_token},
        })
        .done(function(response) {
            swal("",response, "error");
            $('.btn-voucher').prop("disabled", false);
            $('.btn-voucher').html("Imprimir");
            console.log(response);
        })
        .fail(function(err) {
            if(err.responseText=="exito"){
                window.location.href="/voucher/"+clave;
            }else{
                swal("",err.responseText, "error");
                $('.btn-voucher').prop("disabled", false);
                $('.btn-voucher').html("Imprimir");
                console.log(err.responseText);
            }
        })
        .always(function() {
            console.log("complete");
        });
        
    });
    
    function valida(e){
        tecla = (document.all) ? e.keyCode : e.which;
        if (tecla==8){
            return true;
        }
        patron =/[0-9]/;
        tecla_final = String.fromCharCode(tecla);
        return patron.test(tecla_final);
    }
     $("#msvalid").hide();
    window.onload = (function(){
        try{
            $("#holder_email").on('keyup', function(){                
                var value = $(this).val().length;
                if(value > 5){
                    if(validarEmailC($(this).val()) != 1){
                        $("#msvalid").show();
                        $("#msvalid").text('Ingrese un correo válido');
                        $("#msvalid").css('color','#c51d1d');
                        
                    }else{
                        $("#msvalid").hide();
                    }
                }else{
                   if(value < 1){
                        $("#msvalid").text('Dato requerido');
                        $("#msvalid").css('color','#c51d1d');
                    }
                }
                
            }).keyup();
             
        }catch(e){}});

    function validarEmailC(valor) {
        if (/^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/i.test(valor)) {
            return 1;
        } else {
            return 0;
        }
    }

    function validarnumero(valor){
        if(valor.length != 10){
        return 0;
        }else{
            return 1;
        }
    }
    function fillQuotation(){
        localStorage.setItem('fillQuotationForm', true);
    }

});
cargarCarruselBranding();
function cargarCarruselBranding() {
    //
    //<div id="carouselTicker" class="carouselTicker">
    //	<ul class="carouselTicker__list">
    //		@foreach(Util::getImage() as $x)
    //		<li class="carouselTicker__item">
    //			<img src="https://{{env('RepositorioProveedores')}}/Interfaz/2016/logos/logo{{$x}}.png" alt="Proveedor">
    //		</li>
    //		@endforeach
    //	</ul>
    //</div>
    if (typeof imgdata != 'undefined') {
        flagCarga = 0;
        var carrusel = $('<div />', {
            id: 'carouselTicker',
            'class': 'carouselTicker'
        });

        var carruselList = $('<ul />', {
            'class': 'carouselTicker__list'
        });

        //var data = JSON.parse($('#imageData').html());

        $.each(imgdata, function (i, v) {
            var li = $('<li />', {
                'class': 'carouselTicker__item'
            });

            var img = $('<img />', {
                alt: 'Proveedor',
                src: v
            });

            $(img).on('load', function () {
                flagCarga = flagCarga + 1;
            });

            $(li).append(img);
            $(carruselList).append(li);
        });

        $(carrusel).append(carruselList);

        $($('.blackBranding')[0]).append(carrusel);
        // $("#carouselTicker").carouselTicker();

        var i = setInterval(function () {
            if ($.fn.carouselTicker && flagCarga >= imgdata.length) {
                $(".blackBranding").show();
                //console.log('se creara la tira');
                $('#carouselTicker').carouselTicker({
                    mode: "horizontal",
                    speed: 2,
                    delay: 37,
                    reverse: false
                });
                clearInterval(i);
            }
        }, 1000);

        $(window).resize(function () {
            $('#carouselTicker').carouselTicker().resizeTicker();
        });

    }
}

(function ($) {
    let interval = setInterval(() => {
        if($('.carousel').length > 0){
            var touchStartX = null;
            $('.carousel').each(function () {
                var $carousel = $(this);
                $(this).on('touchstart', function (event) {
                    var e = event;
                    if (e.touches.length == 1) {
                        var touch = e.touches[0];
                        touchStartX = touch.pageX;
                    }
                }).on('touchmove', function (event) {
                    var e = event;
                    if (touchStartX != null) {
                        var touchCurrentX = e.changedTouches[0].pageX;
                        if ((touchCurrentX - touchStartX) > 60) {
                            touchStartX = null;
                            $carousel.carousel('prev');
                        } else if ((touchStartX - touchCurrentX) > 60) {
                            touchStartX = null;
                            $carousel.carousel('next');
                        }
                    }
                }).on('touchend', function () {
                    touchStartX = null;
                }).on('mousedown', function (event) {
                    var e = event;
                    touchStartX = e.pageX;
                }).on('mousemove', function (event) {
                    var e = event;
                    if (touchStartX != null) {
                        var touchCurrentX = e.pageX;
                        if ((touchCurrentX - touchStartX) > 60) {
                            touchStartX = null;
                            $carousel.carousel('prev');
                        } else if ((touchStartX - touchCurrentX) > 60) {
                            touchStartX = null;
                            $carousel.carousel('next');
                        }
                    }
                }).on('mouseup', function () {
                    touchStartX = null;
                });
            });
            clearInterval(interval)
        }
    }, 1000)
    setTimeout(() => { clearInterval(interval) }, 20000);
})(jQuery);